import { createElement, forwardRef } from 'react';
import { divider } from '../patterns/divider.mjs';
import { splitProps } from '../helpers.mjs';
import { styled } from './factory.mjs';

export const Divider = /* @__PURE__ */ forwardRef(function Divider(props, ref) {
  const [patternProps, restProps] = splitProps(props, divider.propKeys)
  const styleProps = divider.raw(patternProps)
  const mergedProps = { ref, ...styleProps, ...restProps }
  return createElement(styled["div"], mergedProps)
})